/**
 * Sidebar undo notice (ticket 3531, upstream pin e3e7cc3f, MIT). Adapted from
 * `apps/web/src/components/sidebar/SidebarThreadUndoNotice.tsx`: forge has no
 * `sidebar` Alert variant (the default renders the same quiet card) and no
 * `InlineButton` (the link Button plays that part), and keybindings come from
 * the forge server state hook instead of the upstream server atom.
 *
 * @module SidebarThreadUndoNotice
 */
import { undoLatestThreadAction, useThreadUndoNotice } from "../../hooks/showThreadUndoNotice";
import { shortcutLabelForCommand } from "../../keybindings";
import { useServerKeybindings } from "../../rpc/serverState";
import { Alert, AlertDescription } from "../ui/alert";
import { Button } from "../ui/button";

export function SidebarThreadUndoNotice() {
  const notice = useThreadUndoNotice((state) => state.notice);
  const keybindings = useServerKeybindings();

  if (!notice) return null;
  const shortcut = shortcutLabelForCommand(keybindings, "thread.undo");

  return (
    <Alert className="mx-2 mt-2" role="status">
      <AlertDescription>
        {notice.action} {notice.count} thread{notice.count === 1 ? "" : "s"},{" "}
        <Button
          className="h-auto p-0 align-baseline"
          onClick={undoLatestThreadAction}
          size="xs"
          variant="link"
        >
          {shortcut ? `${shortcut} to undo` : "Undo"}
        </Button>
      </AlertDescription>
    </Alert>
  );
}
